import { type TranslatedTexts } from './translations-types'
import en from '../../assets/translations/en.json'
import it from '../../assets/translations/it.json'
import { RecurrenceTranslations, TranslationsManager } from '@cents/translations-utils'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const defaultTranslations: Map<string, any> = new Map<string, any>(
  Object.entries({
    en,
    it,
  })
)

function buildTranslations(): TranslationsManager<RecurrenceTranslations.RecurrenceTranslatedTexts & TranslatedTexts> {
  // Adding app translations
  const translations = new TranslationsManager().addTranslations<TranslatedTexts>(defaultTranslations)

  // Adding donation recurrence translations
  return RecurrenceTranslations.addDonationRecurrenceTranslations(translations)
}
export const translations = buildTranslations()
